export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-10.5b89f59c.jpg";